import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const HERO = "https://images.unsplash.com/photo-1580478491436-fd6a937acc9e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setBusy(true);
    try { const u = await login(email, password); nav(u.role === "admin" ? "/admin" : "/"); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="grid lg:grid-cols-2 min-h-[calc(100vh-4rem)]">
      <div className="hidden lg:block relative overflow-hidden"><img src={HERO} alt="" className="img-cover" /><div className="absolute inset-0 bg-ink/20" /></div>
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <p className="label-caps text-muted-foreground mb-3">Store access</p>
          <h1 className="font-serif-display text-5xl font-light tracking-tighter mb-10">Admin sign in</h1>
          {error && <p className="text-destructive text-sm mb-4" data-testid="login-error">{error}</p>}
          <div className="space-y-6">
            <div><label className="label-caps text-muted-foreground">Email</label><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="w-full bg-transparent border-b border-line py-3 text-base focus:outline-none focus:border-ink transition-colors" /></div>
            <div><label className="label-caps text-muted-foreground">Password</label><input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="w-full bg-transparent border-b border-line py-3 text-base focus:outline-none focus:border-ink transition-colors" /></div>
          </div>
          <button type="submit" disabled={busy} className="w-full bg-ink text-pearl py-4 label-caps mt-10 hover:bg-wine transition-colors disabled:opacity-50" data-testid="login-submit">{busy ? "Signing in..." : "Sign in"}</button>
        </form>
      </div>
    </div>
  );
}
